import { render, staticRenderFns } from "./edit-likert-modal.vue?vue&type=template&id=851cf780&"
import script from "./edit-likert-modal.vue?vue&type=script&lang=ts&"
export * from "./edit-likert-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports